<template>
  <div class="footer_introduce">
		<div class="margin">
			<div class="txt">Copyright © 2016 - 2019 京ICP备16046113号-2   京文网（2016）3839-487号</div>
			<div class="txt">增值电信业务经营许可证 京B2-20160100<img src="../../images/batb.png" style="display: inline; margin: 0px 5px;vertical-align: middle;">京公网安备 11010502036036号</div>
			<div class="txt">健康游戏公告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防上当受骗 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</div>
			<div class="txt">未满18周岁的未成年人用户请在家长的监督下进行游戏</div>
			<div class="txt">举报邮箱：jubao@datangyouxi-inc.com</div>
			<p class="txt">北京棋开德胜科技有限公司版权所有</p>
		</div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
	 @import '../../components/style/mixin';
	.footer_introduce {
	  width:100%;
	  height:100%;
	  background-color:#282828;
	  .margin{
	  	padding:35px 0px;
	  	.txt{
	  		line-height:30px;
		  	text-align: center;
		  	@include sc(14px, #a1a1a1);
	  	}
	  }
	}
</style>
